export default __webpack_public_path__ + "static/mall-c9137171e9c18c99bba4fa1b636835f1.jpg";